import { render, staticRenderFns } from "./MopubIcon.vue?vue&type=template&id=21dfebc8&"
import script from "./MopubIcon.vue?vue&type=script&lang=js&"
export * from "./MopubIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports